var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubsidy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5L15 5.5",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7311 5.5C13.7311 5.5 21 11.875 21 17.1875C21 22.5 16.0706 22.5 14.9232 22.5H9.07684C7.92939 22.5 3 22.5 3 17.1875C3 11.875 10.269 5.5 10.269 5.5",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8386 5.5C13.369 5.5 13.8777 5.28929 14.2528 4.91421L17.667 1.5H5.33299L9.78516 5.06174",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1981 11.4375C12.1981 11.1959 11.9832 11 11.7181 11C11.453 11 11.2381 11.1959 11.2381 11.4375V11.8787C10.8447 11.905 10.4786 12.0692 10.2071 12.3343C9.91109 12.6234 9.75 13.0095 9.75 13.4062C9.75 13.803 9.91109 14.1891 10.2071 14.4782C10.4786 14.7433 10.8447 14.9075 11.2381 14.9338V16.25H10.23C9.9649 16.25 9.75 16.4459 9.75 16.6875C9.75 16.9291 9.9649 17.125 10.23 17.125H11.2381V17.5625C11.2381 17.8041 11.453 18 11.7181 18C11.9832 18 12.1981 17.8041 12.1981 17.5625V17.1243C12.6156 17.1124 13.0068 16.9451 13.2929 16.6657C13.5889 16.3766 13.75 15.9905 13.75 15.5938C13.75 15.197 13.5889 14.811 13.2929 14.5218C13.0068 14.2424 12.6156 14.0751 12.1981 14.0632V12.75H12.95C13.2151 12.75 13.43 12.5541 13.43 12.3125C13.43 12.0709 13.2151 11.875 12.95 11.875H12.1981V11.4375ZM11.2381 12.7602C11.1182 12.7822 11.0029 12.8396 10.9089 12.9314C10.7849 13.0525 10.71 13.2228 10.71 13.4062C10.71 13.5897 10.7849 13.76 10.9089 13.8811C11.0029 13.9729 11.1182 14.0303 11.2381 14.0523V12.7602ZM12.1981 14.9394V16.2481C12.3405 16.237 12.4805 16.1766 12.5911 16.0686C12.7151 15.9475 12.79 15.7772 12.79 15.5938C12.79 15.4103 12.7151 15.24 12.5911 15.1189C12.4805 15.0109 12.3405 14.9505 12.1981 14.9394Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsidy);
export default __webpack_public_path__ + "static/media/subsidy.3f76becea56b8b72c6e479516f69838f.svg";
export { ForwardRef as ReactComponent };